
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import blackLogo from 'images/padlet_logo_black.svg'
import whiteLogo from 'images/padlet_logo_white.svg'
import rainbowLogo from 'images/padlet_logo_rainbow.png'
import { currentHostWithProtocol } from 'bits/location'

export enum LogoType {
  SingleColor = 'SingleColor',
  Rainbow = 'Rainbow',
  Light300 = 'Light300',
  Dark300 = 'Dark300',
}

@Component
export default class PadletLogo extends Vue {
  @Prop({ default: false }) darkMode!: boolean
  @Prop({ required: false }) href!: string
  @Prop({ default: LogoType.SingleColor }) type?: LogoType

  currentHostWithProtocol = currentHostWithProtocol
  LogoType = LogoType

  get logo(): string {
    if (this.type === LogoType.Rainbow) {
      return rainbowLogo
    }
    if (this.type === LogoType.Light300) {
      return whiteLogo
    }
    if (this.type === LogoType.Dark300) {
      return blackLogo
    }
    return this.darkMode ? whiteLogo : blackLogo
  }
}
